module.exports = __webpack_public_path__ + "static/media/dorm.0617c009.jpg";